import renderService from '@/pages/BusinessCommerces/pages/Shippings/renderers/renderService';
import type { ExternalOperatorShippingDetail } from '../services/externalOperatorShippings.endpoints';
import type { ColumnConfig } from '@/components/table/Table';
import type { MarkerData } from '@/components/maps';

const EMPTY = 'N/A';
const ROUTING_ZONE_TYPE_NAME = 'routingZone';

const text = (value?: string | null, fallback: string = EMPTY): string =>
  value && String(value).trim() ? String(value) : fallback;

const renderTimeSlot = (timeSlot: ExternalOperatorShippingDetail['timeSlot']) => {
  const range =
    timeSlot?.from && timeSlot?.to ? `${timeSlot.from} - ${timeSlot.to}` : '';

  if (!range) return <span className='text-sm'>{EMPTY}</span>;
  return <span className='text-sm'>{range}</span>;
};

const routingZoneLabel = (zones: ExternalOperatorShippingDetail['zones']): string =>
  zones
    .filter((zone) => zone.zoneTypeName === ROUTING_ZONE_TYPE_NAME)
    .map((zone) => zone.zoneName)
    .filter(Boolean)
    .join(', ') || EMPTY;

export const getShippingStatusColumns = (
  shipping: ExternalOperatorShippingDetail,
  pickupMarker: MarkerData | null,
  onShowPickupMap: () => void
): ColumnConfig[] => [
  {
    label: 'Estado',
    field: 'status',
    render: () => <span className='text-sm'>{text(shipping.status)}</span>,
  },
  {
    label: 'Servicio',
    field: 'service',
    render: () => {
      const swo = shipping.serviceWithOperator;
      const serviceName =
        (typeof swo === 'object' && swo
          ? swo.commercialName || swo.name
          : typeof swo === 'string'
            ? swo
            : null) ||
        shipping.service ||
        null;
      const swoId =
        shipping.serviceWithOperatorId ??
        (typeof swo === 'object' && swo ? swo.id : undefined);

      return renderService(serviceName, {
        serviceWithOperatorId: swoId,
      } as any);
    },
  },
  {
    label: 'Número de factura',
    field: 'invoiceNumber',
    render: () => (
      <span className='text-sm'>{text(shipping.invoiceNumber)}</span>
    ),
  },
  {
    label: 'Sucursal',
    field: 'branch',
    render: () => <span className='text-sm'>{text(shipping.branch)}</span>,
  },
  {
    label: 'Dirección de origen',
    field: 'origin',
    render: () =>
      pickupMarker ? (
        <button
          onClick={onShowPickupMap}
          className='text-sm text-blue-600 hover:text-blue-800 hover:underline cursor-pointer text-left'
        >
          {text(shipping.originAddress)}
        </button>
      ) : (
        <span className='text-sm'>{text(shipping.originAddress)}</span>
      ),
  },
  {
    label: 'Detalle de retiro',
    field: 'pickupDetails',
    render: () => (
      <span className='text-sm'>{text(shipping.pickupDetails)}</span>
    ),
  },
  {
    label: 'Franja Horaria',
    field: 'timeSlot',
    render: () => renderTimeSlot(shipping.timeSlot),
  },
  {
    label: 'Tamaño',
    field: 'size',
    render: () => <span className='text-sm'>{text(shipping.size)}</span>,
  },
  {
    label: 'Último conductor',
    field: 'lastDriverName',
    render: () => (
      <span className='text-sm'>{text(shipping.lastDriverName)}</span>
    ),
  },
  {
    label: 'Zona',
    field: 'zone',
    render: () => (
      <span className='text-sm'>{routingZoneLabel(shipping.zones)}</span>
    ),
  },
];
